import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faArrowDown,
  faArrowUp,
} from '@fortawesome/pro-solid-svg-icons';

type SortOrder = 'asc' | 'desc';

interface SortSectionProps {
  currentOrder: SortOrder | null;
  isActive: boolean;
  onChange: (order: SortOrder) => void;
}

const SortSection: React.FC<SortSectionProps> = ({
  currentOrder,
  isActive,
  onChange,
}) => {
  const isAscSelected = isActive && currentOrder === 'asc';
  const isDescSelected = isActive && currentOrder === 'desc';

  return (
    <>
      <div className="px-4 py-2 text-xs font-semibold text-neutral-500 uppercase tracking-wide text-left">
        Sort By
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onChange('desc');
        }}
        className="w-full px-4 py-2 text-sm text-left hover:bg-neutral-100 transition-colors flex items-center justify-between"
      >
        <div className="flex items-center gap-2">
          <Icon
            icon={faArrowDown}
            className={`text-base ${
              isDescSelected ? 'text-sky-600' : 'text-neutral-500'
            }`}
          />
          <span
            className={`${
              isDescSelected ? 'text-sky-600 font-medium' : 'text-neutral-700'
            }`}
          >
            Descending
          </span>
        </div>
        {isDescSelected && (
          <Icon icon={faCheck} className="text-sm text-sky-600" />
        )}
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onChange('asc');
        }}
        className="w-full px-4 py-2 text-sm text-left hover:bg-neutral-100 transition-colors flex items-center justify-between"
      >
        <div className="flex items-center gap-2">
          <Icon
            icon={faArrowUp}
            className={`text-base ${
              isAscSelected ? 'text-sky-600' : 'text-neutral-500'
            }`}
          />
          <span
            className={`${
              isAscSelected ? 'text-sky-600 font-medium' : 'text-neutral-700'
            }`}
          >
            Ascending
          </span>
        </div>
        {isAscSelected && (
          <Icon icon={faCheck} className="text-sm text-sky-600" />
        )}
      </button>
    </>
  );
};

export default SortSection;
